import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
import React, { useEffect, useState } from 'react'

enum Position {
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  backButtonPosition: Position
  fontColor: string
  text: string
  image: any
}
const BackButton = ({ backgroundColor, backButtonPosition, fontColor, text, image }: Props) => {
  const [showBackButton, setShowBackButton] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1000) {
        setShowBackButton(true)
      } else {
        setShowBackButton(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const StickyWrapper = ({ children, position }: { children: any; position: Position }) => {
    const backPositionClass = position === Position.Right ? 'bottom-24 right-0' : 'bottom-24 left-0'
    const transformClass = showBackButton ? '-translate-y-0 opacity-100' : 'translate-y-150 opacity-0'

    return (
      <div
        className={`fixed z-50 ${backPositionClass} ${transformClass} transition-transform duration-700 ease-in-out`}
      >
        {children}
      </div>
    )
  }

  const Content = ({ backgroundColor, fontColor, text, image }: any) => {
    return (
      <div
        className="relative p-6 rounded-l-3xl shadow-md"
        style={{ backgroundColor, color: fontColor, zIndex: '999' }}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <div className="flex flex-col items-center justify-center mx-2">
          <CdnImage
            className="index-2 relative inline-block h-12 w-12 m-2 my-2"
            url={image}
            alt={'Cheveron Up'}
            lazyLoad={false}
          />
          <span className="mt-3">{text}</span>
        </div>
      </div>
    )
  }

  return (
    <>
      <StickyWrapper position={backButtonPosition}>
        <Content backgroundColor={backgroundColor} fontColor={fontColor} text={text} image={image} />
      </StickyWrapper>
    </>
  )
}
export default BackButton
Builder.registerComponent(BackButton, {
  name: 'BackButton',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'green'
    },
    {
      name: 'backButtonPosition',
      type: 'string',
      defaultValue: 'right',
      enum: ['left', 'right']
    },
    {
      name: 'fontColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'text',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    }
  ]
})
